import React, { PropsWithChildren, useState } from 'react'
import { remCalc, concatStyles } from 'utils'
import { NavigatorTheme } from './NavigatorContext'

const BORDER_STYLES = `absolute border-b`

interface IItemBorderProps {
  appearanceTheme?: NavigatorTheme
  topItem?: boolean
}

const ItemBorder: React.FC<IItemBorderProps> = ({
  appearanceTheme,
  topItem,
}) => {
  const secondary = appearanceTheme === 'secondary'
  const paddingX = secondary ? remCalc(18) : 0
  const borderColor = secondary ? 'border-navdivideralt' : 'border-navdivider'

  return (
    <span
      className={concatStyles([BORDER_STYLES, borderColor])}
      style={{
        top: topItem ? '-1px' : 'auto',
        bottom: topItem ? 'auto' : '-1px',
        left: paddingX,
        right: paddingX,
      }}
    />
  )
}

type ItemMouseHandler = React.MouseEventHandler<HTMLLIElement>

const ITEM_STYLES = `flex m-0 px-0 py-0 relative`

export interface IDrawerItemProps {
  appearanceTheme?: NavigatorTheme
  active?: boolean
  topItem?: boolean
  onMouseOver?: ItemMouseHandler
  onMouseOut?: ItemMouseHandler
}

export const DrawerItem: React.FC<PropsWithChildren<IDrawerItemProps>> = ({
  children,
  topItem,
  active,
  appearanceTheme,
  onMouseOver,
  onMouseOut,
}) => {
  const [hover, setHover] = useState<boolean>(false)

  const handleMouseOver: ItemMouseHandler = (e) => {
    onMouseOver?.(e)
    setHover(true)
  }
  const handleMouseOut: ItemMouseHandler = (e) => {
    onMouseOut?.(e)
    setHover(false)
  }

  return (
    <li
      className={ITEM_STYLES}
      onMouseOut={handleMouseOut}
      onMouseOver={handleMouseOver}
    >
      {topItem && !active ? (
        <ItemBorder appearanceTheme={appearanceTheme} topItem />
      ) : null}
      {children}
      {!hover && !active ? (
        <ItemBorder appearanceTheme={appearanceTheme} />
      ) : null}
    </li>
  )
}
